import { version as ReactVersion } from 'react';

import { App } from './App';
import { parseSpaConfig } from './utils';
import type { AppConfiguration } from '~/models';

export const render = async (rootElement: HTMLElement): Promise<boolean> => {
  if (!rootElement.dataset.config) {
    return false;
  }
  const config = parseSpaConfig(rootElement.dataset.config, [
    'currentLanguage',
    'customerId',
    'staticApiUrl',
    'tenant',
  ]);
  const configuration: AppConfiguration = {
    currentLanguage:
      typeof __CURRENT_LANGUAGE__ === 'string' ? __CURRENT_LANGUAGE__ : config.currentLanguage,
    customerId: config.customerId,
    staticApiUrl: config.staticApiUrl,
    tenant: typeof __TENANT__ === 'string' ? __TENANT__ : config.tenant,
  };
  if (ReactVersion.startsWith('18')) {
    const { createRoot } = await import('react-dom/client');
    createRoot(rootElement).render(<App configuration={configuration} />);
  } else {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console -- log error to console
      console.error('react-dom/client cannot be imported using legacy render');
    }
    const { render: reactDomRender } = await import('react-dom');
    reactDomRender(<App configuration={configuration} />, rootElement);
  }

  return true;
};
